<template>
    <el-dialog :title="isEdit ? $t('EDIT_CLIENT_USER') :$t('ADD_CLIENT_USER')"
            visible
            width="40%"
            @close="onCancel">
        <!--<el-alert
          class="mgb10"
          type="info"
          :title="$t('email_warn')"
          show-icon>
        </el-alert>-->
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="240px"
                 class="demo-ruleForm">
            <el-form-item :label="$t('USER_WORKING_EMAIL')" prop="userAccount">
                <el-autocomplete
                        :disabled="isEdit"
                        :maxlength="100"
                        class="inline-input email-inpu-cls"
                        v-model="ruleForm.userAccount"
                        :fetch-suggestions="querySearch"
                        :placeholder="$t('email_warn')"
                        :trigger-on-focus="false"
                        @change="userAccountChange(false)"
                        @select="userAccountChange(false)"/>
            </el-form-item>
            <el-form-item :label="$t('COMMON_USER_NAME')" prop="userName">
                <el-input v-model="ruleForm.userName" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('TABLE_HEADER_title2')"
                          prop="title">
                <el-input v-model="ruleForm.title"
                          maxlength="50"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="role" v-if="!this.isEdit">
                <label class="roles-label" slot="label"><span class="required-icon">*</span>{{ $t('TABLE_HEADER_Roles') }}</label>
                <el-select style="width: 100%"
                           v-model="ruleForm.role"
                           multiple
                           filterable>
                    <el-option v-for="item in roleList"
                               :key="item.roleId"
                               :label="item.roleName"
                               :value="item.roleId">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item :label="$t('TABLE_HEADER_CLIENT_IDENTITY')"
                          prop="identityType"
            >
                <el-select style="width: 100%"
                           v-model="ruleForm.identityType"
                           :placeholder="$t('TABLE_HEADER_CLIENT_IDENTITY')"
                           filterable>
                    <el-option v-for="item in identityTypeOpt"
                               :key="item.code"
                               :label="item.value"
                               :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                    v-if="initData.id"
                    :label="$t('BACKUP_MAILBOX')"
                    prop="backMail">
                <el-input v-model="ruleForm.backMail"
                          :placeholder="$t('BACKUP_MAILBOX_DESC')"
                          maxlength="50"></el-input>
                <div class="backup-warning">* {{ $t('BACKUP_MAILBOX_WARNING')}}</div>
            </el-form-item>
            <el-form-item :label="$t('TABLE_HEADER_ifContact')"
                          prop="ifContact">
                <el-switch
                        v-model="ruleForm.ifContact"
                        class="switch-width-cls"
                        active-color="#409EFF"
                        inactive-color="#cccccc">
                </el-switch>
            </el-form-item>
            <div class="autofill-tip" v-show="titleTipSites">
                {{ $t('clientUserAddTitleTip', {sites: titleTipSites}) }}
            </div>
        </el-form>

        <span slot="footer"
              class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 :loading="saveLoading"
                 @click="onConfirm"
                 class="wl-green">{{$t('btn_save')}}</el-button>
    </span>
    </el-dialog>
</template>
<script>
    import {UserInput} from '@/utils'
    import {mapGetters} from "vuex";
    import API from '@/api'

    export default {
        data() {
            return {
                isEdit: false,
                ruleForm: {
                    userAccount: '',
                    userName: '',
                    title: '',
                    role: [],
                    ifContact: false,
                    backMail: '',
                    identityType: ''
                },
                rules: {
                    userAccount: [
                        {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'},
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        },
                        {
                            type: 'email', //要检验的类型（number，email，date等）
                            message: this.$t('FORM_VALIDATE_EMAIL'),
                            trigger: ['blur', 'change']
                        }
                    ],
                    userName: [
                        {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'},
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        }
                    ],
                    title: [
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        }
                    ],
                    // role: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}],
                    backMail: [{
                        type: 'email', //要检验的类型（number，email，date等）
                        message: this.$t('FORM_VALIDATE_EMAIL'),
                        trigger: 'blur'
                    }],
                    identityType: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}]
                },
                titleTipSites: ''
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            })
        },
        methods: {
            userAccountChange(onlyShow = false) {
                const form = new FormData()
                form.append('userAccount', this.ruleForm.userAccount)
                API.clientUser.queryExistClientUserInfo(form).then(res => {
                    if (res.code == '1' && res.data !== null) {
                        if (!onlyShow) {
                            this.ruleForm.userName = res.data.userName
                            this.ruleForm.title = res.data.title
                            this.ruleForm.identityType = res.data.identityType
                        }
                        this.titleTipSites = res.data.ownedSiteName.join(',')
                    }
                })
            },
            onConfirm() {
               
                // 新增时添加确认窗口，修改没有
                if (this.initData.id) {
                    this.$refs.ruleForm.validate(validate => {
                        if (validate) {
                            this.onAdd(this.ruleForm)
                        }
                    })
                } else {
                    this.$refs.ruleForm.validate(validate => {
                        if (validate) {
                            // if(this.ruleForm.role.length > 0) {
                            //     this.$confirm(this.$t('client_user_add_warning'), '', {
                            //         dangerouslyUseHTMLString: true,
                            //         confirmButtonText: this.$t('btn_confirm'),
                            //         cancelButtonText: this.$t('btn_cancel'),
                            //         type: 'warning'
                            //     }).then(() => {
                            //         this.onAdd(this.ruleForm)
                            //     }).catch(() => {
                            //     });
                            // } else {
                                this.$confirm(this.$t('client_user_add_warning2'), '', {
                                    dangerouslyUseHTMLString: true,
                                    confirmButtonText: this.$t('btn_ok'),
                                    cancelButtonText: this.$t('btn_cancel'),
                                    type: 'warning'
                                }).then(() => {
                                    this.$confirm(this.$t('client_user_add_warning'), '', {
                                        dangerouslyUseHTMLString: true,
                                        confirmButtonText: this.$t('btn_confirm'),
                                        cancelButtonText: this.$t('btn_cancel'),
                                        type: 'warning'
                                    }).then(() => {
                                        this.onAdd(this.ruleForm)
                                    }).catch(() => {
                                    });
                                }).catch(() => {
                                });
                            // }
                        }
                    })
                }
            },
            querySearch(queryString, callback) {
                let emailList = this.emailList
                let index = queryString.indexOf('@')
                let results = {}
                if (index != -1) {
                    //过滤处理
                    let queryStringTemp = queryString.substring(0, index)
                    results = this.dealEamilOpotions(emailList, queryStringTemp)
                    results = results.filter(item => item.value.indexOf(queryString) != -1)
                } else {
                    results = this.dealEamilOpotions(emailList, queryString)
                }
                callback(results)
            },
            dealEamilOpotions(emailList, queryString) {
                //添加尾缀
                let results = JSON.parse(JSON.stringify(emailList))
                for (let item in emailList) {
                    results[item].value = queryString + '' + emailList[item].value
                }
                return results
            }
        },
        mounted() {
            if (this.initData.id) {
                this.isEdit = true
                let role = []
                if (this.initData.roleList && this.initData.roleList.length > 0) {
                    this.initData.roleList.forEach((i, n) => {
                        role.push(i.roleId)
                    })
                }
                this.ruleForm.userAccount = this.initData.userAccount
                this.ruleForm.userName = this.initData.userName
                this.ruleForm.title = this.initData.title
                this.ruleForm.role = role
                this.ruleForm.ifContact = this.initData.ifContact
                this.ruleForm.backMail = this.initData.backMail
                this.ruleForm.identityType = this.initData.identityType
                this.userAccountChange(true)
            }
        },
        props: {
            onAdd: Function,
            onCancel: Function,
            saveLoading: Boolean,
            initData: [String, Object],
            emailList: Array,
            roleList: [Array],
            identityTypeOpt: [Array]
        }
    }
</script>
<style scoped>
    .wl-m-select {
        width: 100%;
    }

    .email-inpu-cls {
        width: 100%;
    }

    .backup-warning {
        color:#fd349c;
        font-size: 10px;
        line-height: 17px;
    }
    .roles-label{
        text-align: right;
    }
    .roles-label .required-icon{
        color: #F56C6C;
        margin-right: 0.020833rem
    }
    .autofill-tip {
        color: #e6a23c;
    }
    .mgb10 {
        margin-bottom: 10px;
    }
</style>
